let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4BJlc")).then(() => parcelRequire('lfSuk'));